/**
 * Service worker registration (TICKET FE-016).
 *
 * The worker itself lives in `public/sw.js`, unbundled, because it is fetched
 * by the browser at a fixed URL rather than imported by the app.
 *
 * The kill switch is the important part. A service worker survives a hard
 * reload: if this mechanism ever misbehaves the way the cached `index.html` did
 * in September, `?sw=off` unregisters it and empties its caches. It is checked
 * before registering, so the escape hatch works even when the worker is the
 * thing that is broken.
 */
export function registerServiceWorker(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  if (new URLSearchParams(window.location.search).get("sw") === "off") {
    void navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) void registration.unregister();
    });
    if (typeof caches !== "undefined") {
      void caches.keys().then((keys) => {
        for (const key of keys) void caches.delete(key);
      });
    }
    return;
  }

  // After load: registering during startup competes with the first API calls on
  // exactly the connections that need them most.
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // A refused registration is not a failure worth showing: the application
      // works without it, it simply will not open offline.
    });
  });
}
